import layoutMain from '@/layout/main'
// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
import dashboard from '@/views/dashboards/index'
const meta = { auth: true }

export default {
  path: '/dashboard',
  name: 'dashboard',
  component: layoutMain,
  children: [
    { path: ':id', name: 'dashboard-id', component: dashboard, meta, },
  ]
}
